import { ShamDashboardData } from 'sham-components/features/dashboard';
import {
  ShamDiscountTag01TwotoneIcon,
  ShamInvoice03Icon,
  ShamLaurelWreathFirst02Icon,
  ShamLayers01Icon,
  ShamMarketingIcon,
  ShamNews01Icon,
  ShamPackageIcon,
  ShamPlusSignTwotoneIcon,
  ShamPropertyNewIcon,
  ShamSettingsIcon,
  ShamUser03Icon,
  ShamWhiteboardIcon,
  ShamSigninIcon,
  ShamSignupIcon,
} from 'sham-components/icons';

export async function dashboardLayoutDataFactory(dashData: ShamDashboardData) {
  dashData.navLinks.set([
    {
      name: 'nav.introSwiper',
      paths: 'intro-swiper',
      icon: ShamLaurelWreathFirst02Icon,
    },
    {
      name: 'nav.popularCategories',
      paths: 'popular-categories',
      icon: ShamLayers01Icon,
    },
    {
      name: 'nav.marketingBanners',
      paths: 'marketing-banners',
      icon: ShamMarketingIcon,
    },
    {
      name: 'nav.highlightedAds',
      paths: 'highlighted-ads',
      icon: ShamWhiteboardIcon,
    },
    {
      name: 'nav.wideMarketingBanners',
      paths: 'wide-marketing-banners',
      icon: ShamMarketingIcon,
    },
    {
      name: 'nav.featuredProducts',
      paths: 'featured-products',
      icon: ShamPackageIcon,
    },
    // {
    //   name: 'Best Sellers',
    //   paths: 'best-sellers',
    //   icon: ShamDiscountTag01TwotoneIcon,
    // },
    {
      name: 'nav.greatDeals',
      paths: 'great-deals',
      icon: ShamInvoice03Icon,
    },
    {
      name: 'nav.loginMedia',
      paths: 'login-media',
      icon: ShamSigninIcon,
    },
    {
      name: 'nav.registerMedia',
      paths: 'register-media',
      icon: ShamSignupIcon,
    },
    {
      name: 'nav.blog',
      paths: 'blog',
      icon: ShamNews01Icon,
    },
    {
      name: 'generalSettings.title',
      paths: 'general-settings',
      icon: ShamSettingsIcon,
    },
    // {
    //   name: 'New Arrivals',
    //   paths: 'new-arrivals',
    //   icon: ShamPropertyNewIcon,
    // },
  ]);
}
